module.exports = __webpack_public_path__ + "static/media/b0_p5_clickable.13d0ca68.png";